import { Card, Form, Button, Row, Col } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { useEffect, useState } from "react";
import { GetCUserInfoV2 } from "../../Redux/Actions/UserInfoV2Actions";
import "./style.css";
import {
  useFormik
} from "formik"
import Spinner from "../../Components/UI/Spinner/Spinner";
import {cols} from "./userInfoV2Constant"
import CsvDownloader from "react-csv-downloader";

const UserInfoV2 = () => {
    const dispatch = useDispatch();
    const UserInfoV2State = useSelector(
        (state: IReduxState) => state.UserInfoV2
      );

    const [csvData, setCsvData] = useState([])

      const validate = (values: { user_id: string }) => {
        const errors: { user_id?: string } = {};
      
        // Validate user_id
        if (!values.user_id) {
          errors.user_id = 'This field is required.';
        } else if (values.user_id.length < 5 || values.user_id.length > 50) {
          errors.user_id = 'Please enter a string between 5 and 50 characters.';
        }
      
        return errors;
      };

      let csvColumns = cols.map((column: any) => ({
        id: column.Header,
        displayName: column.Header,
      }));

      const formik: any = useFormik({
        initialValues: {
          user_id: "",
        },
        validate,
        onSubmit: (value, { resetForm }) => {
            dispatch(GetCUserInfoV2(value.user_id));
        },
      });

      useEffect(() => {
        dispatch(GetCUserInfoV2(""));
      }, [dispatch]);
    
      useEffect(() => {
        if (UserInfoV2State.data && UserInfoV2State.data.userData) {
          setCsvData(UserInfoV2State.data.userData.map((obj: { key: any; value: any; }) => [obj.key, obj.value]));
        }
      }, [UserInfoV2State.data]);

      return (
        <>
          <Row className="d-flex justify-content-center mt-3">
            <Row>
              <h3 className="module_title" style={{ marginBottom: '0px' }}>
              User API Info 2
                <p>View user UUPD</p>
              </h3>
            </Row>
          </Row>
          <Card>
            <Card.Body>
              <div className="expertFilter">
                <div className="expertFilterFields">
                  <div className="position-relative">
                    <Form.Control
                      id="example-date"
                      type="text"
                      name="user_id"
                      className="fsz-875rem"
                      value={formik.values.user_id}
                      onChange={formik.handleChange}
                      isInvalid={!!formik.errors?.user_id}
                    />
                  </div>
                  <div className="btngrp">
                    <Button
                      className="noMargin"
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                      variant="success"
                    >
                      Submit
                    </Button>
                  </div>
                </div>
                {/* <Button className="ExportBtn" onClick={(e) => {
                  formik.setFieldValue('csv', true)
                  formik.handleSubmit(e)
                  // formik.resetForm()
                }}
    
                >
                  Export to CSV
                </Button> */}
                <CsvDownloader
                  datas={csvData}
                  columns={csvColumns}
                  text="Export to CSV"
                  filename={`user_info_v2_` + new Date().toLocaleString()}
                  extension=".csv"
                  className="btn btn-primary ExportBtn no-margin"
                />
              </div>
              <div className="position-relative">
                {formik.errors.user_id ? (
                  <span
                    style={{
                      color: "#dc3545",
                      fontFamily: "Silka",
                      fontSize: 12,
                    }}
                  >
                    {formik.errors.user_id}
                  </span>
                ) : formik.errors?.ip ? (
                  <span
                    style={{
                      color: "#dc3545",
                      fontFamily: "Silka",
                      fontSize: 12,
                    }}
                  >
                    {formik.errors?.ip}
                  </span>
                ) : formik.errors?.sha1 ? (
                  <span
                    style={{
                      color: "#dc3545",
                      fontFamily: "Silka",
                      fontSize: 12,
                    }}
                  >
                    {formik.errors?.sha1}
                  </span>
                ) : null}
              </div>
              {UserInfoV2State.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)}
              <Table
                columns={cols}
                data={UserInfoV2State?.data?.userData?UserInfoV2State.data.userData:[]}
                striped={true}
              />
            </Card.Body>
          </Card>
        </>
      );
    };
    
    export default UserInfoV2;

